import { render, staticRenderFns } from "./IconArrowNarrowUpSolid.vue?vue&type=template&id=5226fa2a"
import script from "./IconArrowNarrowUpSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports